import { render, staticRenderFns } from "./initial-visitor-number.vue?vue&type=template&id=4b0e9b32&scoped=true&"
import script from "./initial-visitor-number.vue?vue&type=script&lang=ts&"
export * from "./initial-visitor-number.vue?vue&type=script&lang=ts&"
import style0 from "./initial-visitor-number.vue?vue&type=style&index=0&id=4b0e9b32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0e9b32",
  null
  
)

export default component.exports